import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "101e100b-4859-449e-8ec5-11b4b6836abd",
    label: "DG(BLDG)'s Office Order No. 26 of 2011-2012",
    date: "02/01/2012",
    subject: "Format for notice case intimation",
  },
  {
    fileStoreId: "d2ad4f72-d613-414c-be48-c5e65acb1619",
    label: "DG(BLDG)'s Office Order No. 25 of 2011-2012",
    date: "31/12/2011",
    subject: "Bar on regularisation of nursing home",
  },
  {
    fileStoreId: "0d7155f9-5ed2-4774-92ef-45cbd312dc93",
    label: "DG(BLDG)'s Office Order No. 23 of 2011-2012",
    date: "12/12/2011",
    subject: "	Sanction of Hospital or nursing home without concent of DG",
  },
  {
    fileStoreId: "a6641c17-8d92-4710-9f23-8fcb4e72957a",
    label: "DG(BLDG)'s Office Order No. 19 of 2011-2012",
    date: "12/09/2011",
    subject: "No exemption in FAR fot internal stair and check NOC for tax",
  },
];

const Building_OfficeOreder_2011 = () => (
  <TableStructure
    title="Office Order/ 2012"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2011;
